import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';

const ENV = getEnvironmentVariables();

/**
 * True in unit/CT/Ember test builds (`environment === 'test'|'playwright'`), and in
 * qonto-js-react local/E2E runs where the app meta tag sets `useLocal` from
 * `VITE_BACKEND_USE_LOCAL` (`pnpm start:local`, `build:e2e-local`).
 *
 * Do not read `import.meta.env` here: shared-kit is consumed by Ember and Playwright CT,
 * where Vite env is not reliably available. App config is exposed via getEnvironmentVariables().
 */
export const isTesting =
  ENV.environment === 'test' || ENV.environment === 'playwright' || ENV.useLocal === true;

export const isDevelopingApp = ENV.environment === 'development';
